// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L3Z6H"};